import React, { ComponentPropsWithRef } from 'react'

import InfiniteList from 'components/InfiniteList'
import Section from 'components/Section'

import { StyledTable } from './WorkspaceList.styles'

import { UserWorkspaceMembershipFragment } from 'gqlTypes'
import { WorkspaceListItem } from './Item/WorkspaceListItem'
import { useUserAuthorizations } from 'modules/sso/operations'

interface WorkspaceListProps {
  memberships: UserWorkspaceMembershipFragment[]
  onLoadMore: ComponentPropsWithRef<typeof InfiniteList>['onLoadMore']
  linkButton?: React.ReactNode
  onLeaveWorkspace: (membership: UserWorkspaceMembershipFragment) => void
}

const WorkspaceList: React.FC<WorkspaceListProps> = props => {
  const { memberships, linkButton, onLoadMore, onLeaveWorkspace } = props
  const { hasAccessToWorkspace } = useUserAuthorizations()

  return (
    <Section
      title="Workspaces"
      text="Workspaces are where you’ll save your work and collaborate with others."
      action={linkButton}>
      <InfiniteList onLoadMore={onLoadMore}>
        <StyledTable
          header={[
            { label: 'Workspace Name' },
            { label: 'Role' },
            { label: 'Leave Workspace' },
          ]}
          hideHeader
          items={memberships}
          renderItem={(membership: UserWorkspaceMembershipFragment) => {
            return (
              <WorkspaceListItem
                membership={membership}
                onLeaveWorkspace={onLeaveWorkspace}
                hasAccessToWorkspace={
                  hasAccessToWorkspace(membership.workspace) === true
                }
              />
            )
          }}
        />
      </InfiniteList>
    </Section>
  )
}

export default WorkspaceList
